// The tooltip layer in charge. A Forms page mounts one TooltipLayer; if two
// are ever mounted at once, only the newest handles events. InfoTip and the
// tour reach the active layer through here.

const layers = [];

export const registerTipLayer = (layer) => {
  layers.push(layer);
  return () => {
    const i = layers.indexOf(layer);
    if (i !== -1) layers.splice(i, 1);
  };
};

export const activeTipLayer = () => layers[layers.length - 1] || null;

export const isActiveTipLayer = (layer) => activeTipLayer() === layer;

export const hideTip = () => {
  const layer = activeTipLayer();
  if (layer) layer.hide();
};

// "?" buttons: pin the tip open, or close it when it is already pinned.
export const toggleTip = (el) => {
  const layer = activeTipLayer();
  if (layer) layer.toggle(el);
};
